import React from 'react'
import { useCheckout, CheckoutProps } from './useCheckout'
import { Link } from 'react-router-dom'
import Layout from 'components/Layout/Layout'
import styles from './Checkout.module.scss'
import SuccessSection from './SuccessSection/SuccessSection'
import CheckoutForm from './CheckoutForm/CheckoutForm'

const Checkout: React.FC<CheckoutProps> = (props: CheckoutProps) => {
  const {
    restaurantName,
    isLoading,
    cartItems,
    orderId,
    customerName,
    currency,
    whatsappURL,
    totalPrice,
    isDeliveryOrderSuccess,
  } = useCheckout(props)

  return (
    <Layout>
      <main className={styles.checkout_wrapper}>
        <div className={styles.head_container}>
          <h1 className={styles.title}>
            <Link to={`/${restaurantName}/Cart`} className={styles.link}>
              <i className='bi bi-arrow-left-circle me-2'></i>
            </Link>
            Checkout
          </h1>
        </div>

        {isDeliveryOrderSuccess && !cartItems ? (
          <SuccessSection
            orderId={orderId}
            restaurantName={restaurantName}
            customerName={customerName}
            currency={currency}
            whatsappURL={whatsappURL}
            totalPrice={totalPrice}
          />
        ) : (
          <CheckoutForm
            isLoading={isLoading}
            restaurantName={restaurantName}
            cartItems={cartItems}
          />
        )}
      </main>
    </Layout>
  )
}

export default Checkout
